import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { getEasing } from "../../utils/getEasing.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { injectInteractionBar } from "../../utils/injectInteractionBar.mjs.mjs";
import { injectOSXFontSmoothing } from "../../utils/injectOSXFontSmoothing.mjs.mjs";
const getFieldBorderColor = ({ props, theme, hover, }) => {
    if (props.disabled)
        return theme.colors.interaction.secondary.disabled;
    if (props.invalid)
        return theme.colors.ui.error;
    if (hover)
        return theme.colors.interaction.secondary.hover;
    return theme.colors.interaction.secondary.default;
};
export const StyledContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledContainer", componentId: "auir-611444a-takq5b" }) `
  padding-top: 0.8125em;
  padding-top: ${(props) => !props.empty && '0'};
  &:focus-within {
    padding-top: 0;
  }

  cursor: ${(props) => props.disabled && 'not-allowed'};

  transition: padding 0.25s var(${getEasing});

  ${injectSpacing('margin')}
`;
export const StyledInnerContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledInnerContainer", componentId: "auir-611444a-iq25tc" }) `
  border-color: var(
    ${(props) => getFieldBorderColor({ props, theme: props.theme, hover: false })}
  );
  border-style: solid;
  border-width: 1px;
  &:hover {
    border-color: var(
      ${(props) => getFieldBorderColor({ props, theme: props.theme, hover: true })}
    );
  }

  border-bottom: none;

  transition-timing-function: var(${getEasing});
  transition-duration: 0.25s;
  transition-property: border-color, padding;

  ${injectInteractionBar}
`;
export const StyledTextAreaContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledTextAreaContainer", componentId: "auir-611444a-1s59fe" }) `
  padding: var(${(props) => props.theme.responsive.spacing.s});
`;
export const StyledTextArea = styled.textarea.withConfig({ displayName: "auir-611444a-StyledTextArea", componentId: "auir-611444a-oltzp9" }) `
  all: revert;

  display: block;
  box-sizing: border-box;
  width: 100%;
  padding-top: ${(props) => !props.empty && '0.8125em'};

  color: var(${(props) => props.theme.colors.interaction.secondary.filled});

  background-color: transparent;
  border: none;

  cursor: ${(props) => props.disabled && 'not-allowed'};

  transition: padding 0.25s var(${getEasing});

  resize: vertical;

  &:focus {
    padding-top: 0.8125em;
  }

  &:hover {
    color: var(${(props) => props.theme.colors.interaction.secondary.hover});
  }

  &:disabled {
    color: var(${(props) => props.theme.colors.interaction.secondary.disabled});
  }

  ${(props) => injectTypography(props, 'copy1')}
  ${injectOSXFontSmoothing(true)}
`;
//# sourceMappingURL=TextArea.styles.mjs.mjs.map